import { render } from "./AlumniView.vue?vue&type=template&id=3054e037"
import script from "./AlumniView.vue?vue&type=script&lang=js"
export * from "./AlumniView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__